<div class="modal-header">
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body mx-3">
  <h3>{{ "upload_csv_modal.title" | translate }}</h3>

  <div class="mt-3">
    <label class="form-label">{{ "upload_csv_modal.select_file" | translate }}</label>

    <input
      type="file"
      accept=".csv,.txt"
      class="form-control h-auto"
      (change)="onFileSelected($event)"
    />

    <!-- Messaggio di successo -->
    <div *ngIf="selectedFile" class="mt-2 text-success">
      {{ "upload_csv_modal.selected" | translate }}: {{ selectedFile.name }}
    </div>

    <!-- Messaggio errore file non valido -->
    <div *ngIf="fileError" class="mt-2 text-danger">
      {{ "upload_csv_modal.invalid_file" | translate }}
    </div>
  </div>

  <div class="d-flex align-items-center gap-3 mt-4">
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="!selectedFile"
      (click)="upload()"
    >
      {{ "upload_csv_modal.upload" | translate }}
    </button>
  </div>
</div>
